import { forwardRef } from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import CardContent from '@mui/material/CardContent';

import { TAny } from 'types';

export interface IRemoveVideoProps {
  loading: boolean;
  isPanelVisible: boolean;
  isDisabledButton: boolean;
}

const RemoveVideo = forwardRef(
  (
    { loading, isPanelVisible, isDisabledButton }: IRemoveVideoProps,
    ref: TAny
  ) => {
    const SkeletonMedia = () => {
      return (
        <Skeleton
          variant="rectangular"
          sx={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
          }}
        />
      );
    };

    return (
      <Card
        sx={{
          visibility: isPanelVisible ? 'visible' : 'hidden',
        }}>
        <CardContent>
          {' '}
          <Grid container spacing={4}>
            <Grid item xs={12} sm={6} md={4.8}>
              <Typography variant="h6">Original</Typography>
              <Box
                sx={{
                  position: 'relative',
                  paddingBottom: '56.25%',
                  height: 0,
                }}>
                {loading && <SkeletonMedia />}
                <Box
                  ref={ref[0]}
                  component="video"
                  id="video"
                  controls={!isDisabledButton}
                  sx={{
                    visibility:
                      loading || !isPanelVisible ? 'hidden' : 'visible',
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                  }}>
                  <source
                    ref={ref[1]}
                    id="currentVID"
                    src=""
                    type="video/mp4"
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={4.8}>
              <Typography variant="h6">Result</Typography>
              <Box
                sx={{
                  position: 'relative',
                  paddingBottom: '56.25%',
                  height: 0,
                }}>
                {loading && <SkeletonMedia />}
                <Box
                  ref={ref[2]}
                  component="canvas"
                  id="output"
                  sx={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    visibility:
                      loading || !isPanelVisible || !isDisabledButton
                        ? 'hidden'
                        : 'visible',
                  }}></Box>

                <Box
                  ref={ref[4]}
                  component="video"
                  id="output"
                  controls={!isDisabledButton}
                  autoPlay
                  sx={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    visibility:
                      loading || !isPanelVisible || isDisabledButton
                        ? 'hidden'
                        : 'visible',
                  }}>
                  <source ref={ref[5]} src="" type='video/mp4; codecs="hvc1"' />
                </Box>
              </Box>
            </Grid>

            <Grid container item xs={12} sm={6} md={2.4} alignItems="flex-end">
              <Button
                ref={ref[3]}
                disabled={isDisabledButton}
                component="a"
                variant="contained"
                size="large">
                Download
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }
);

export default RemoveVideo;
